import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle, FiAlertTriangle, FiXCircle, FiHelpCircle } = FiIcons;

const ScoreDisplay = ({ score }) => {
  const getScoreColor = (score) => {
    if (score >= 90) return 'from-green-500 to-emerald-600';
    if (score >= 70) return 'from-blue-500 to-cyan-600';
    if (score >= 40) return 'from-yellow-500 to-orange-600';
    return 'from-red-500 to-rose-600';
  };

  const getScoreIcon = (score) => {
    if (score >= 90) return FiCheckCircle;
    if (score >= 70) return FiCheckCircle;
    if (score >= 40) return FiAlertTriangle;
    return FiXCircle;
  };

  const getScoreText = (score) => {
    if (score >= 90) return 'Highly Real';
    if (score >= 70) return 'Most Likely Real';
    if (score >= 40) return 'Uncertain / Needs More Proof';
    return 'Likely Fake / Burner / Dummy Account';
  };

  return (
    <div className="mt-8">
      <div className="flex items-center justify-center space-x-4 mb-6">
        <SafeIcon icon={getScoreIcon(score)} className={`text-4xl ${score >= 40 ? 'text-green-400' : 'text-red-400'}`} />
        <div className="text-center">
          <div className="text-6xl font-bold text-white mb-2">{score}</div>
          <div className="text-lg text-purple-300">Realness Score</div>
        </div>
      </div>
      <div className="relative">
        <div className="w-full bg-gray-700 rounded-full h-4 mb-4">
          <motion.div 
            className={`h-4 rounded-full bg-gradient-to-r ${getScoreColor(score)}`}
            initial={{ width: 0 }}
            animate={{ width: `${score}%` }}
            transition={{ duration: 1.5, ease: "easeOut" }}
          />
        </div>
        <div className="text-center text-lg font-medium text-white">
          {getScoreText(score)}
        </div>
      </div>
      <div className="grid grid-cols-4 gap-2 mt-6 text-xs text-center">
        <div className="text-red-400">0-39<br/>Likely Fake</div>
        <div className="text-yellow-400">40-69<br/>Uncertain</div>
        <div className="text-blue-400">70-89<br/>Most Likely Real</div>
        <div className="text-green-400">90-100<br/>Highly Real</div>
      </div>
    </div>
  );
};

export default ScoreDisplay;